module.exports = __webpack_public_path__ + "static/1-f80070036cc7d7ec4430916b0384d72f.png";